module.exports = __webpack_public_path__ + "static/media/camion_completo.7988f1a1.svg";